import { render, staticRenderFns } from "./DataSetTable.vue?vue&type=template&id=ef722e70&scoped=true"
import script from "./DataSetTable.vue?vue&type=script&lang=js"
export * from "./DataSetTable.vue?vue&type=script&lang=js"
import style0 from "./DataSetTable.vue?vue&type=style&index=0&id=ef722e70&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef722e70",
  null
  
)

export default component.exports